import type {
  DMMoneyProcessingFailedData,
  DMMoneySource,
  DMPocketEventType
} from '@nsftx/systems-sdk'
import PubSub from 'pubsub-js'

export const MONEY_PROCESSING_EVENT_ID = Symbol(`DM:Pocket.MoneyProcessing`)

/** All pocket money events except `ready` (includes `moneyProcessingFailed`). */
export type DMPocketMoneyEventType = Exclude<DMPocketEventType, 'ready'>

export type DMPocketMoneyProcessingCallbackData = {
  amount: string
  source: DMMoneySource
  type: Exclude<DMPocketEventType, 'ready' | 'moneyProcessingFailed'>
  currency?: string
}

export type DMPocketMoneyEventData =
  DMPocketMoneyProcessingCallbackData | DMMoneyProcessingFailedData

export const moneyProcessingPubSub: PubSubJS.Base<
  DMPocketMoneyEventData,
  typeof MONEY_PROCESSING_EVENT_ID
> = PubSub
